import type { TourDefinition } from '../../../models/tour.interfaces';

export const posTour: TourDefinition = {
  module: 'pos',
  steps: [
    {
      id: 'caja_step_1',
      order: 1,
      target: '[data-testid="btn-open-cash"]',
      title: 'Abre la caja',
      body: 'Antes de cobrar, necesitas abrir tu caja registradora. Haz clic aquí para comenzar.',
      requiredAction: 'click',
      nextStepTrigger: 'onElementClick',
      placement: 'bottom',
      skippable: true,
    },
    {
      id: 'caja_step_2',
      order: 2,
      target: '[data-testid="cash-initial-amount"]',
      title: 'Monto inicial',
      body: 'El "último arqueo" es el dinero en efectivo que quedó en tu caja cuando la cerraste por última vez. Si es tu primera vez, estará en S/ 0.00.',
      requiredAction: 'none',
      nextStepTrigger: 'onNextButton',
      placement: 'right',
      skippable: false,
    },
    {
      id: 'caja_step_3',
      order: 3,
      target: '[data-testid="btn-confirm-open-cash"]',
      title: 'Confirma apertura',
      body: 'Haz clic para confirmar la apertura de caja y poder empezar a cobrar.',
      requiredAction: 'click',
      nextStepTrigger: 'onElementClick',
      placement: 'bottom',
      skippable: false,
    },
    {
      id: 'caja_step_4',
      order: 4,
      target: '[data-testid="btn-add-sale-client"]',
      title: 'Registra un cliente',
      body: 'Para vender necesitas un cliente. Haz clic en "Añadir nuevo cliente" para registrar uno.',
      requiredAction: 'click',
      nextStepTrigger: 'onElementClick',
      placement: 'bottom',
      skippable: true,
    },
    {
      id: 'caja_step_5',
      order: 5,
      target: '[data-testid="pos-add-client-modal"]',
      title: 'Completa los datos',
      body: 'Para este tutorial puedes usar datos de un amigo o familiar. Llena nombre, apellido y un correo electrónico. Tip: siempre que puedas, pide también el DNI, fecha de nacimiento y celular. Así podrás enviarles saludos de cumpleaños, promociones y recordatorios.',
      requiredAction: 'none',
      nextStepTrigger: 'onTargetDisappear',
      placement: 'right',
      skippable: true,
    },
    {
      id: 'caja_step_6',
      order: 6,
      target: '[data-testid="btn-new-sale"]',
      title: 'Agrega servicios o productos',
      body: 'Usa los botones "+ Servicio", "+ Producto" o "+ Paquete" para agregar lo que vas a cobrar.',
      requiredAction: 'click',
      nextStepTrigger: 'onElementClick',
      placement: 'top',
      skippable: true,
    },
    {
      id: 'caja_step_7',
      order: 7,
      target: '[data-testid="sale-add-service"]',
      title: 'Selecciona "Servicios"',
      body: 'Haz clic en "Servicios" para abrir el formulario donde podrás buscar y agregar un servicio a la venta.',
      requiredAction: 'click',
      nextStepTrigger: 'onElementClick',
      placement: 'top',
      skippable: true,
    },
    {
      id: 'caja_step_8',
      order: 8,
      target: '[data-testid="pos-add-service-modal"]',
      title: 'Busca y agrega un servicio',
      body: 'Escribe el nombre del servicio en el campo "Buscar servicio", selecciónalo de la lista, elige el empleado que lo realizará y haz clic en "Agregar".',
      requiredAction: 'none',
      nextStepTrigger: 'onTargetDisappear',
      placement: 'top',
      skippable: true,
    },
    {
      id: 'caja_step_9',
      order: 9,
      target: '[data-testid="pos-sales-container"]',
      title: 'Servicio agregado',
      body: 'El servicio se agregó a tu venta. Aquí puedes ver el detalle: nombre, colaborador asignado, cantidad y precio. Puedes seguir agregando más o continuar con el cobro.',
      requiredAction: 'none',
      nextStepTrigger: 'onNextButton',
      placement: 'right',
      skippable: false,
    },
    {
      id: 'caja_step_10',
      order: 10,
      target: '[data-testid="sale-document-type"]',
      title: 'Tipo de comprobante',
      body: 'Selecciona el tipo de comprobante. Para este tutorial, elige "Nota de venta" (no requiere facturación electrónica).',
      completedBody: 'Comprobante seleccionado. Haz clic en Siguiente.',
      requiredAction: 'select',
      nextStepTrigger: 'onNextButton',
      placement: 'left',
      skippable: false,
      completionCheck: (el) => {
        const select = el.querySelector('select') as HTMLSelectElement;
        return select ? select.value !== '' && select.value !== '0' : false;
      },
    },
    {
      id: 'caja_step_11',
      order: 11,
      target: '[data-testid="pos-sale-summary"]',
      title: 'Resumen de la venta',
      body: 'Aquí puedes ver el resumen con subtotal, IGV, descuentos y el total a pagar. Revisa que todo esté correcto antes de cobrar.',
      requiredAction: 'none',
      nextStepTrigger: 'onNextButton',
      placement: 'left',
      skippable: false,
    },
    {
      id: 'caja_step_12',
      order: 12,
      target: '[data-testid="btn-process-sale"]',
      title: 'Cobrar la venta',
      body: 'Haz clic en "Cobrar" para abrir la ventana de pago donde podrás seleccionar el medio de pago y finalizar la venta.',
      requiredAction: 'click',
      nextStepTrigger: 'onElementClick',
      placement: 'top',
      skippable: false,
    },
    {
      id: 'caja_step_13',
      order: 13,
      target: '[data-testid="pos-payout-modal"]',
      title: 'Ventana de cobro',
      body: 'En esta ventana selecciona el medio de pago (efectivo, tarjeta, etc.), ingresa el monto y haz clic en "Finalizar venta" para completar tu primera venta. ¡Felicitaciones!',
      requiredAction: 'none',
      nextStepTrigger: 'onTargetDisappear',
      placement: 'top',
      skippable: true,
    },
  ],
};
